import { NG_VALIDATORS, Validator, AbstractControl, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { Directive } from '@angular/core';

/**
 * Directiva para establecer la validación de un campo de emails encadenados por punto y coma
 * @example
 * <label>Emails</label><br/>
 * <input type="text" [(ngModel)]="editDialogsCasService.email" name="email" pInputText maxlength="300" emailValidator/>
 * @tutorial
 * https://codeburst.io/angular-4-custom-validation-for-template-based-forms-b7dee9be48a6
 */
@Directive({
  selector: '[emailValidator][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }
  ]
})
export class EmailValidatorDirective implements Validator {

  validator: ValidatorFn;

  constructor() {
    this.validator = this.emailValidator();
  }

  validate(control: AbstractControl) {
    return this.validator(control);
  }

  emailValidator(): ValidatorFn {
    return (c: AbstractControl) => {
      let emails: string = c.value !== undefined && c.value !== null ? c.value : "";
      let emilios = emails.split(';')
      for (let i = 0; i < emilios.length; i++) {
        const email = emilios[i];
        if (!this.checkEmail(email)) {
          return {
            emailValidator: { valid: false }
          };
        }
      }
      return null;
    }
  }

  private checkEmail(email: string) {
    return /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(email)
      || email === undefined
      || email === null
      || email === "";
  }

}
